import { createSlice } from "@reduxjs/toolkit";

const ticketPayloadSlice = createSlice({
  name: "ticketPayload",
  initialState: {
    payload: {
      eventId: null,
      ticketId:null,
      feeDeduction:null,
      ticketCategory: null,
      ticketPhoto: null,
      color: null,
      code: null,
      ticketType: [],
      ticketTemplate: null,
    },
  },
  reducers: {
    setTicketPayload: (state, action) => {
      state.payload = action.payload;
    },
    clearTicketPayload: (state) => {
      state.payload = {
        ticketId:null,
        feeDeduction:null,
        eventId: null,
        ticketCategory: null,
        ticketPhoto:null,
        color: null,
        code: null,
        ticketType: [],
        ticketTemplate: null,
      };
    },
  },
});

export const { setTicketPayload, clearTicketPayload } = ticketPayloadSlice.actions;
export default ticketPayloadSlice.reducer;
